import { AxiosError } from "axios";
import { useMemo } from "react";
import useSWR from "swr";

import { OrganizationUserDetails } from "@organization/models/OrganizationUserDetails";

import { userEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetUserByOrganizationId(
  organizationId: string,
  userId: string | null
) {
  let url: null | string = null;

  if (organizationId && userId) {
    url = userEndpoints.getUserByOrganizationId(organizationId, userId);
  }

  const { data, error, isLoading } = useSWR<
    OrganizationUserDetails,
    AxiosError
  >(url, fetcher, { revalidateOnFocus: false });

  return useMemo(() => ({ data, isLoading, error }), [data, isLoading, error]);
}
